/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
import { AllowRegistrationDomain } from './AllowRegistrationDomain';
import { BlockRegistrationDomain } from './BlockRegistrationDomain';
const RegistrationDomainParser = 
/* #__PURE__ */ /* #__PURE__ */ parsers.taggedUnion('type', [
    ['allow', AllowRegistrationDomain],
    ['block', BlockRegistrationDomain],
]);
export const RegistrationDomain = RegistrationDomainParser;
